import { Dispatch } from "redux";
import {
    setAdaptiveAuthenticationReferenceData,
    setAdaptiveAuthenticationReferenceDataLoading
} from "@redux/actions/adaptive-authentication-actions";
import { getAdaptiveAuthenticationReferenceDataRequest } from "@requests/reports/get-adaptive-authentication-reference-data";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getAdaptiveAuthenticationReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setAdaptiveAuthenticationReferenceDataLoading(true));
    const { data, error } = await getAdaptiveAuthenticationReferenceDataRequest();
    if (data) {
        dispatch(setAdaptiveAuthenticationReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setAdaptiveAuthenticationReferenceDataLoading(false));
    }
};